// Client-side configuration
export const config = {
  // API Configuration
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
    timeout: 10000, // 10 seconds
  },
  
  // Environment
  env: {
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
  },
  
  // Feature flags
  features: {
    enableDebugMode: import.meta.env.VITE_DEBUG_MODE === 'true',
    enableMockData: import.meta.env.VITE_USE_MOCK_DATA === 'true',
  },
} as const;

// API helper functions
export const apiConfig = {
  getBaseUrl: () => config.api.baseUrl,
  getApiUrl: (endpoint: string) => `${config.api.baseUrl}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`,
  getHeaders: () => ({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }),
} as const;
